module.exports = __webpack_public_path__ + "img/744.58728a39.jpg";